import React from "react";
import StandardSizeContainer from "../customComponent/Container/StandardSizeContainer";
import pageData from "../config/careersPageData.json";
import CustomParagraph from "../customComponent/Title/CustomParagraph";
import { Container } from "../components/container/Container";
import ImageList from "../customComponent/List/ImageList";
import Image from "../components/image/Image";

import JobCard from "../customComponent/JobCard";

const CareerPage = () => {
  const { description, descriptionTwo, benefits, imageSrc, openPositions } =
    pageData.careersSection;

  return (
    <StandardSizeContainer>
      {/* <HeadingTitle text={title} /> */}
      <CustomParagraph text={description} />
      <CustomParagraph text={descriptionTwo} />
      <Container className="flex flex-col md:flex-row items-center md:items-start py-2 px-4 md:px-6 gap-8 md:gap-24">
        <div className="w-full md:w-1/2">
          <ImageList items={benefits} />
        </div>

        <div className="w-full md:w-1/2 flex justify-center md:justify-end">
          <Image
            src={imageSrc}
            alt="Career illustration"
            className="w-full max-w-sm h-auto object-contain"
          />
        </div>
      </Container>
      <Container>
        {/* <CardsJobs openPositions={openPositions} /> */}
        <div className="container mx-auto px-4 py-8">
          <JobCard jobs={openPositions} />
        </div>
      </Container>
    </StandardSizeContainer>
  );
};

export default CareerPage;
